export default __webpack_public_path__ + "static/media/flag-hong-kong.939f9805.svg";